module.exports = __webpack_public_path__ + "img/google05.3d59edbd.jpg";